<template>
  <CommonPageShell
    :title="text.create.page.title"
    :subtitle="text.create.page.subtitle"
    :actions="headerActions"
    @action="onHeaderAction"
  >
    <template #content>
      <section class="simple-note-create-page">
        <SimpleNoteCreateTopSection
          :customer-options="customerOptions"
          :selected-receiver="selectedReceiver"
          :note-info="noteInfo"
          @select-receiver="selectReceiver"
          @note-info-change="onNoteInfoChange"
        />

        <SimpleNoteCreateConceptsCard
          :concepts="concepts"
          :currency="currency"
          @add-concept="addConcept"
          @edit-concept="editConcept"
          @delete-concept="deleteConcept"
        />

        <SimpleNoteCreateConceptModal
          :show="showConceptModal"
          :mode="conceptModalMode"
          :initial-data="editingConceptData"
          :existing-concepts="concepts"
          :currency="currency"
          :prefill-payment-id="prefillPaymentId"
          :selected-receiver="selectedReceiver"
          @close="closeConceptModal"
          @submit="submitConceptFromModal"
        />

        <SimpleNoteCreateBottomSection
          :comments="comments"
          :total="total"
          :currency="currency"
          @comments-change="onCommentsChange"
        />

        <SimpleNoteCreateFooterActions
          :submitting="submittingSimpleNote"
          @reset-draft="resetDraft"
          @preview="previewSimpleNote"
          @submit="submitSimpleNote"
        />
      </section>
    </template>
  </CommonPageShell>
</template>

<script>
import CommonPageShell from '@/components/common/CommonPageShell.vue';
import SimpleNoteCreateTopSection from '@/components/simple-notes/create/SimpleNoteCreateTopSection.vue';
import SimpleNoteCreateConceptsCard from '@/components/simple-notes/create/SimpleNoteCreateConceptsCard.vue';
import SimpleNoteCreateConceptModal from '@/components/simple-notes/create/SimpleNoteCreateConceptModal.vue';
import SimpleNoteCreateBottomSection from '@/components/simple-notes/create/SimpleNoteCreateBottomSection.vue';
import SimpleNoteCreateFooterActions from '@/components/simple-notes/create/SimpleNoteCreateFooterActions.vue';
import { useDomainText } from '@/composables/text/useDomainText';
import {
  createSimpleNoteCreateState,
  simpleNoteCreateComputed,
  simpleNoteCreateMethods,
} from '@/composables/simple-notes/useSimpleNoteCreatePage';

const { catalog: simpleNotesText } = useDomainText('simpleNotes');

export default {
  name: 'SimpleNoteCreatePage',
  components: {
    CommonPageShell,
    SimpleNoteCreateTopSection,
    SimpleNoteCreateConceptsCard,
    SimpleNoteCreateConceptModal,
    SimpleNoteCreateBottomSection,
    SimpleNoteCreateFooterActions,
  },
  data() {
    return {
      text: simpleNotesText,
      ...createSimpleNoteCreateState(simpleNotesText),
    };
  },
  async created() {
    await this.initializePage();
  },
  computed: simpleNoteCreateComputed,
  methods: simpleNoteCreateMethods,
};
</script>

<style scoped>
.simple-note-create-page {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
</style>

